import React from 'react'
import {visiblyHidden as vHidden} from '../../../stylesheets/utils.css'

import type {Element} from 'react'

type VisiblyHiddenProps = {
  children?: ?Element<any>
}

export function VisiblyHidden(props: VisiblyHiddenProps) {
  return (
    <span className={vHidden}>
      {props.children}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/VisiblyHidden/index.js